class MediaSlider
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'media-slider--bound'
            @.$slides = @.$el.querySelectorAll '.media-slide'
            @.$controlLeft = @.$el.querySelector '.media-slider--control-left'
            @.$controlRight = @.$el.querySelector '.media-slider--control-right'

            @.activeSlide = 0
            @.touchStart = undefined
            @.touchMove = undefined

            @.$el.classList.add 'media-slider--bound'
            @.InitEvents()
        return

    InitEvents: ->
        @.$slides[0].classList.add 'media-slide--active'
        self = @
        # CLICK
        @.$controlLeft.addEventListener 'click', (e) ->
            self.Slide "prev"
            return
        @.$controlRight.addEventListener 'click', (e) ->
            self.Slide "next"
            return

        # KEYS
        @.$el.addEventListener 'keyup', (e) ->
            if e.key == "ArrowLeft"
                self.Slide "prev"
            if e.key == "ArrowRight"
                self.Slide "next"
            return

        # TOUCH
        @.$el.addEventListener 'touchstart', (e) ->
            self.touchStart = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY
            }
            return
        @.$el.addEventListener 'touchmove', (e) ->
            self.touchMove = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY
            }
            return
        @.$el.addEventListener 'touchend', (e) ->
            # check if variables are set
            if self.touchStart && self.touchMove
                # check if movement on y is not too far
                yDiff = self.touchStart.y - self.touchMove.y
                if Math.abs(yDiff) < self.$el.offsetHeight * .5
                    # check minimum x movement
                    xDiff = self.touchStart.x - self.touchMove.x
                    if Math.abs(xDiff) > window.innerWidth * .4
                        # check direction
                        if xDiff > 0
                            self.Slide "next"
                        else
                            self.Slide "prev"
            return

            self.touchStart = undefined
            self.touchMove = undefined

        return

    Slide: (direction) ->
        window.dispatchEvent new CustomEvent 'stopAllYtVideos', { bubbles: true }
        window.dispatchEvent new CustomEvent 'stopAllVimeoVideos', { bubbles: true }
        window.dispatchEvent new CustomEvent 'stopAllVideos', { bubbles: true }
        @.$slides[@.activeSlide].classList.remove 'media-slide--active'
        if direction == "next"
            @.activeSlide = if @.activeSlide + 1 > @.$slides.length - 1 then 0 else @.activeSlide+1
        else
            @.activeSlide = if @.activeSlide - 1 < 0 then @.$slides.length - 1 else @.activeSlide-1
        @.$slides[@.activeSlide].classList.add 'media-slide--active'
        self = @
        @.$slides.forEach (slide) ->
            slide.style.transform = 'translateX(-' + (self.activeSlide * 100 + 50) + '%)' + (if !slide.classList.contains('media-slide--active') then ' scale(.98)' else '' )
            return
        return

BindMediaSliders = ->
    document.querySelectorAll '.media-slider:not(.media-slider--bound)'
        .forEach (el) ->
            new MediaSlider el
            return
    return

window.addEventListener 'bind-components', BindMediaSliders